export enum FundCardLayoutMode {
	Standard = 'standard',
	ESG = 'esg',
}
